import axios from 'axios';
import getRequestData from "@/helpers/get-request-data";
import getRequestHeaders from "@/helpers/get-request-headers";
import Service from "@/abstracts/service";

class cliffMarketService extends Service {
    constructor() {
        super('p00020');
    }

    /**
     * @param {Number} page
     * @param {Number} limit
     * @param {String} sort
     * @param {String} term
     * @returns {Promise<Object>}
     */
    listOrders(page = 1, limit = 10, sort, term) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_ORDER_LIST_ORDER",
                page: page,
                limit: limit,
                sort: sort,
                term: term
            };

            if (sort === undefined || sort === '') {
                payload.sort = undefined;
            }

            if (term === undefined || term === '') {
                payload.term = undefined;
            }

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let returnValue = {
                        list: [],
                        total: 0
                    };

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        returnValue = {
                            list: payload.data.list,
                            total: payload.data.total
                        };
                    }

                    resolve(returnValue);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {string} orderNumber
     * @returns {Promise<Object>}
     */
    getOrder(orderNumber) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_ORDER_GET_ORDER",
                orderNumber: orderNumber
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let order = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        order = payload.data;
                    }

                    resolve(order);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {Number} page
     * @param {Number} limit
     * @param {Array} filter
     * @returns {Promise<Object>}
     */
    listCustomers(page = 1, limit = 10, filter = []) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_CUSTOMER_LIST_CUSTOMER",
                page: page,
                limit: limit,
                filter: filter
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let returnValue = {
                        list: [],
                        total: 0
                    };

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        returnValue = {
                            list: payload.data.list,
                            total: payload.data.total
                        };
                    }

                    resolve(returnValue);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} customerId
     * @returns {Promise<Object>}
     */
    getCustomer(customerId) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_CUSTOMER_GET_CUSTOMER",
                customer: customerId
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let customer = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        customer = payload.data;
                    }

                    resolve(customer);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {Object} customer
     */
    updateCustomer(customer) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_CUSTOMER_UPDATE_CUSTOMER",
                party: customer.id,
                customerNumber: null,
                salutation: customer.salutation ? customer.salutation : null,
                firstName:  customer.firstName  ? customer.firstName  : null,
                lastName:   customer.lastName   ? customer.lastName   : null,
                company:    customer.company    ? customer.company    : null,
                street:     customer.street     ? customer.street     : null,
                postcode:   customer.postcode   ? customer.postcode   : null,
                city:       customer.city       ? customer.city       : null,
                state:      customer.state      ? customer.state      : null,
                country:    customer.country    ? customer.country    : null,
                birthday:   customer.birthday   ? customer.birthday   : null,
                billingAddress: {
                    salutation: customer.billingAddress.salutation ? customer.billingAddress.salutation : null,
                    firstName:  customer.billingAddress.firstName  ? customer.billingAddress.firstName  : null,
                    lastName:   customer.billingAddress.lastName   ? customer.billingAddress.lastName   : null,
                    company:    customer.billingAddress.company    ? customer.billingAddress.company    : null,
                    vatId:      customer.billingAddress.vatId      ? customer.billingAddress.vatId      : null,
                    street:     customer.billingAddress.street     ? customer.billingAddress.street     : null,
                    postcode:   customer.billingAddress.postcode   ? customer.billingAddress.postcode   : null,
                    city:       customer.billingAddress.city       ? customer.billingAddress.city       : null,
                    state:      customer.billingAddress.state      ? customer.billingAddress.state      : null,
                    country:    customer.billingAddress.country    ? customer.billingAddress.country    : null,
                    birthday:   customer.billingAddress.birthday   ? customer.billingAddress.birthday   : null,
                },
                shippingAddress: {
                    salutation: customer.shippingAddress.salutation ? customer.shippingAddress.salutation : null,
                    firstName:  customer.shippingAddress.firstName  ? customer.shippingAddress.firstName  : null,
                    lastName:   customer.shippingAddress.lastName   ? customer.shippingAddress.lastName   : null,
                    company:    customer.shippingAddress.company    ? customer.shippingAddress.company    : null,
                    vatId:      customer.shippingAddress.vatId      ? customer.shippingAddress.vatId      : null,
                    street:     customer.shippingAddress.street     ? customer.shippingAddress.street     : null,
                    postcode:   customer.shippingAddress.postcode   ? customer.shippingAddress.postcode   : null,
                    city:       customer.shippingAddress.city       ? customer.shippingAddress.city       : null,
                    state:      customer.shippingAddress.state      ? customer.shippingAddress.state      : null,
                    country:    customer.shippingAddress.country    ? customer.shippingAddress.country    : null,
                    birthday:   customer.shippingAddress.birthday   ? customer.shippingAddress.birthday   : null,
                },
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let customer = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        customer = payload.data;
                    }

                    resolve(customer);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }

    /**
     * @param {String} order
     * @param {String} state
     * @returns {Promise<Object>}
     */
    updatePaymentState(order, state) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_ORDER_UPDATE_PAYMENT_STATE",
                order: order,
                state: state
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let updatePaymentResponse = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        updatePaymentResponse = payload.data;
                    }

                    resolve(updatePaymentResponse);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }

    /**
     * @param {String} customer
     * @param {String} groupName
     * @returns {Promise<Object>}
     */
    updateCustomerGroup(customer, groupName) {
        return new Promise((resolve, reject) => {
            const payload = {
                event: "ADMIN_CUSTOMER_UPDATE_CUSTOMER_GROUP",
                customer: customer,
                groupName: groupName
            };

            const requestConfig ={
                headers: getRequestHeaders()
            };

            axios.post(this.url, getRequestData(payload, this.portfolioElement), requestConfig)
                .then(response => {
                    let updateCustomerGroup = {};

                    if (response.status === 200) {
                        let payload = response.data.container[0].payload;
                        updateCustomerGroup = payload.data;
                    }

                    resolve(updateCustomerGroup);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

export default new cliffMarketService();